/* NELLAE — small UI behaviours: dialogs, header rule, gallery, footer columns, privacy link. No dependencies. */
(function () {
  'use strict';

  var Nellae = (window.Nellae = window.Nellae || {});

  try {
    Nellae.config = JSON.parse(document.getElementById('NellaeConfig').textContent);
  } catch (e) {
    Nellae.config = { routes: {}, strings: {}, publishEvents: false };
  }

  Nellae.announce = function (text) {
    var region = document.querySelector('[data-nellae-live]');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(function () { region.textContent = text; }, 50);
  };

  /* ---- Dialogs (native <dialog>: focus trap, Escape and focus return come from the platform) ---- */
  Nellae.openDialog = function (dialog) {
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return false;
    dialog.showModal();
    document.dispatchEvent(new CustomEvent('nellae:dialog', { detail: { open: true, id: dialog.id } }));
    return true;
  };

  Nellae.closeDialog = function (dialog) {
    if (dialog && dialog.open) dialog.close();
  };

  document.addEventListener('click', function (event) {
    var panelLink = event.target.closest('[data-nellae-open-panel]');
    if (panelLink) {
      var host = document.getElementById(panelLink.getAttribute('data-nellae-open-panel'));
      var panel = host && host.querySelector('details.nellae-know--panel');
      if (panel) {
        event.preventDefault();
        panel.open = true;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        var summary = panel.querySelector('summary'); if (summary) summary.focus({ preventScroll: true });
        return;
      }
    }

    var opener = event.target.closest('[data-nellae-dialog-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-nellae-dialog-open'));
      if (Nellae.openDialog(target)) event.preventDefault();
      return;
    }
    var closer = event.target.closest('[data-nellae-dialog-close]');
    if (closer) {
      Nellae.closeDialog(closer.closest('dialog'));
      return;
    }
    /* click on the backdrop */
    if (event.target instanceof HTMLDialogElement && event.target.open) {
      var rect = event.target.getBoundingClientRect();
      var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) event.target.close();
    }
  });

  document.addEventListener('close', function (event) {
    if (event.target instanceof HTMLDialogElement) {
      document.dispatchEvent(new CustomEvent('nellae:dialog', { detail: { open: false, id: event.target.id } }));
    }
  }, true);

  /* ---- Header rule on scroll ---- */
  var header = document.querySelector('[data-nellae-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Gallery: thumbs on desktop, dots on mobile ---- */
  document.querySelectorAll('[data-nellae-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-nellae-gallery-track]');
    var slides = gallery.querySelectorAll('[data-nellae-slide]');
    var thumbs = gallery.querySelectorAll('[data-nellae-thumb]');
    if (!track || slides.length < 2) return;
    var desktop = window.matchMedia('(min-width: 990px)');

    var setCurrent = function (index) {
      thumbs.forEach(function (thumb) {
        if (thumb.getAttribute('data-nellae-thumb') === String(index)) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    };

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();
        var index = thumb.getAttribute('data-nellae-thumb');
        var slide = gallery.querySelector('[data-nellae-slide="' + index + '"]');
        if (!slide) return;
        if (desktop.matches) {
          track.classList.add('has-active');
          slides.forEach(function (item) { item.classList.toggle('is-active', item === slide); });
        } else {
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }
        setCurrent(index);
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (desktop.matches) return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setCurrent(entry.target.getAttribute('data-nellae-slide'));
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (slide) { observer.observe(slide); });
    }
  });

  /* ---- Footer columns: accordions on mobile, always open from 750px ---- */
  var footerCols = document.querySelectorAll('[data-nellae-footer-col]');
  if (footerCols.length) {
    var wide = window.matchMedia('(min-width: 750px)');
    var syncFooter = function () {
      footerCols.forEach(function (col) { if (wide.matches) col.setAttribute('open', ''); else col.removeAttribute('open'); });
    };
    syncFooter();
    if (wide.addEventListener) wide.addEventListener('change', syncFooter);
  }

  /* ---- "Your privacy choices": reopen the consent preferences when the platform exposes them ---- */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-nellae-privacy-choices]');
    if (!link) return;
    var banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') {
      event.preventDefault();
      banner.showPreferences();
    }
  });
})();
